/* svnty-stores.js: THE STORE LOCATOR (STORE_LOCATOR_SVNTY_Part1, 2026-09-26).
 * The section prints every branch as a card; this file adds what a page cannot say in Liquid: open or closed now in Cairo
 * time, the map (every branch pinned, grouped where pins would touch, a tap flies to the branch and opens its card), the
 * shopper's location on request only (never on load, never stored), and the directions chooser on an iPhone or iPad.
 * Every word comes from the section's JSON block. Classic deferred script, no dependencies, ASCII only. */
(function () {
  'use strict';

  var BRANCH_Z = 14;         /* the closest the map frames the shopper and a branch together */
  var FAR_KM = 400;          /* beyond this the map does not travel to the shopper */
  var BOOT_DEADLINE = 15000;

  var slice = function (l) { return Array.prototype.slice.call(l); };
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var fill = function (t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); };
  var UA = navigator.userAgent || '';
  var IOS = /iPad|iPhone|iPod/.test(UA) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  /* ================================================================ Cairo time and the hours */
  function parseRange(text) {
    var m = /^\s*(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})\s*$/.exec(String(text || ''));
    if (!m) return null;
    var open = +m[1] * 60 + +m[2], close = +m[3] * 60 + +m[4];
    if (close <= open) close += 1440; /* a range that ends at or after midnight */
    return [open, close];
  }
  function cairoNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Africa/Cairo', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var h = +o.hour % 24, mi = +o.minute;
      if (!isFinite(h) || !isFinite(mi) || !o.weekday) return null;
      return { day: o.weekday.slice(0, 3), min: h * 60 + mi };
    } catch (e) { return null; }
  }
  var WEEK = ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  function rangeFor(store, day) { return parseRange(day === 'Thu' || day === 'Fri' ? store.thuFri : store.satWed); }
  function nextDay(day) { return WEEK[(WEEK.indexOf(day) + 1) % 7]; }
  function prevDay(day) { return WEEK[(WEEK.indexOf(day) + 6) % 7]; }
  function clockWords(min, S) {
    min = ((min % 1440) + 1440) % 1440;
    if (min === 0) return S.midnight;
    var h = Math.floor(min / 60), m = min % 60, h12 = h % 12 || 12;
    return h12 + (m ? ':' + (m < 10 ? '0' : '') + m : '') + (h < 12 ? ' AM' : ' PM');
  }
  /* { open: bool, words: 'until 11 PM' | 'opens at 10 AM' | 'opens tomorrow at 10 AM' } or null */
  function stateOf(store, now, S) {
    if (!now) return null;
    var today = rangeFor(store, now.day), yday = rangeFor(store, prevDay(now.day));
    if (yday && yday[1] > 1440 && now.min < yday[1] - 1440) return { open: true, words: fill(S.until, { time: clockWords(yday[1], S) }) };
    if (today && now.min >= today[0] && now.min < today[1]) return { open: true, words: fill(S.until, { time: clockWords(today[1], S) }) };
    if (today && now.min < today[0]) return { open: false, words: fill(S.opens_at, { time: clockWords(today[0], S) }) };
    var tmr = rangeFor(store, nextDay(now.day));
    if (tmr) return { open: false, words: fill(S.opens_tomorrow, { time: clockWords(tmr[0], S) }) };
    return null;
  }
  function weekWords(range, S) {
    var r = parseRange(range);
    return r ? clockWords(r[0], S) + ' ' + S.to + ' ' + clockWords(r[1], S) : String(range || '');
  }

  function km(a, b) {
    var R = 6371, rad = Math.PI / 180, dLat = (b.lat - a.lat) * rad, dLng = (b.lng - a.lng) * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  function kmWords(d) { return d < 10 ? d.toFixed(1) : String(Math.round(d)); }

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      if (window.maplibregl) return resolve(window.maplibregl);
      var el = document.createElement('script');
      el.src = url; el.async = true;
      el.onload = function () { window.maplibregl ? resolve(window.maplibregl) : reject(new Error('map library')); };
      el.onerror = function () { reject(new Error('map library')); };
      document.head.appendChild(el);
    });
  }
  function loadCss(url) {
    if (!url || document.querySelector('link[data-svnty-maplibre-css]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = url; l.setAttribute('data-svnty-maplibre-css', '');
    document.head.appendChild(l);
  }
  /* ================================================================ the locator */
  function Stores(root) {
    this.root = root;
    var data = { strings: {}, stores: [] };
    try { data = JSON.parse(root.querySelector('[data-st-data]').textContent); } catch (e) { /* the cards stand alone */ }
    this.S = data.strings || {};
    this.stores = (data.stores || []).map(function (st) { st.lat = +st.lat; st.lng = +st.lng; return st; });
    this.byCode = {};
    this.stores.forEach(function (st) { this.byCode[st.code] = st; }, this);
    this.list = root.querySelector('[data-st-list]');
    this.cards = slice(root.querySelectorAll('[data-st-card]'));
    this.cardByCode = {};
    this.cards.forEach(function (c) { this.cardByCode[c.getAttribute('data-code')] = c; }, this);
    this.status = root.querySelector('[data-st-status]');
    this.here = null;
    this.active = null;
    this.map = null;
    this.pins = null;

    this.paintHours();
    /* a page left open keeps telling the truth: the open state is repainted every minute */
    var self = this;
    setInterval(function () { self.paintHours(); }, 60000);
    this.wireCards();
    this.wireLocate();
    this.wireDoor();
    this.bootMap();
  }

  Stores.prototype.say = function (text) {
    if (!this.status) return;
    /* a live region only speaks a change: clear, then write on the next frame */
    this.status.textContent = '';
    var st = this.status;
    requestAnimationFrame(function () { st.textContent = text || ''; });
  };

  /* ---------------------------------------------------------------- open now, in Cairo time */
  Stores.prototype.stateEl = function (store) {
    var st = stateOf(store, cairoNow(), this.S);
    if (!st) return null;
    var p = document.createElement('span');
    p.className = 'svnty-stores__state ' + (st.open ? 'svnty-stores__state--open' : 'svnty-stores__state--shut');
    var dot = document.createElement('span');
    dot.className = 'svnty-stores__dot'; dot.setAttribute('aria-hidden', 'true');
    var b = document.createElement('span');
    b.className = 'svnty-stores__state-word';
    b.textContent = st.open ? this.S.open_now : this.S.closed_now;
    var w = document.createElement('span');
    w.className = 'svnty-stores__state-when';
    w.textContent = ', ' + st.words;
    p.appendChild(dot); p.appendChild(b); p.appendChild(w);
    return p;
  };
  Stores.prototype.paintHours = function () {
    /* the head's live line: how many branches are open now in Cairo time (the page opens with its title, no eyebrow) */
    var line = this.root.querySelector('[data-st-open-now]');
    if (line && this.S.open_count_now) {
      var now = cairoNow(), S = this.S, n = this.stores.filter(function (st) { var x = st.open ? stateOf(st, now, S) : null; return x && x.open; }).length;
      line.textContent = fill(S.open_count_now, { count: n });
      line.hidden = false;
    }
    this.cards.forEach(function (card) {
      var store = this.byCode[card.getAttribute('data-code')], slot = card.querySelector('[data-st-today]');
      if (!store || !slot || !store.open) return;
      var old = slot.querySelector('.svnty-stores__state');
      if (old) old.remove();
      var el = this.stateEl(store);
      if (el) slot.insertBefore(el, slot.firstChild);
    }, this);
  };

  /* ---------------------------------------------------------------- the cards */
  Stores.prototype.wireCards = function () {
    var self = this;
    this.cards.forEach(function (card) {
      var code = card.getAttribute('data-code');
      var show = card.querySelector('[data-st-show]');
      if (show) show.addEventListener('click', function () { self.select(code, { from: 'list' }); });
      var dir = card.querySelector('[data-st-directions]');
      if (dir) dir.addEventListener('click', function (e) { self.directions(code, e, dir); });
    });
  };

  /* ---------------------------------------------------------------- directions */
  Stores.prototype.directions = function (code, e, opener) {
    var store = this.byCode[code];
    if (!store) return;
    if (!IOS) return; /* one link: the card's own href (Google Maps directions, a new tab) */
    e.preventDefault();
    this.openDoor(store, opener);
  };

  /* THE DOOR: the chooser hangs from the header while it is open (the status bar law), the page behind it is inert */
  Stores.prototype.wireDoor = function () {
    var self = this;
    this.door = this.root.querySelector('[data-st-door]');
    if (!this.door) return;
    this.doorHome = this.door.parentNode;
    this.sheet = this.door.querySelector('[data-st-sheet]');
    this.layer = this.door.querySelector('[data-st-layer]');
    slice(this.door.querySelectorAll('[data-st-door-close]')).forEach(function (b) {
      b.addEventListener('click', function () { self.closeDoor(); });
    });
    this.layer.addEventListener('click', function (e) { if (e.target === self.layer) self.closeDoor(); });
    this.door.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeDoor(); return; }
      if (e.key !== 'Tab') return;
      /* the page behind is inert; this keeps Tab cycling inside the sheet in engines without inert */
      var f = slice(self.sheet.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    slice(this.door.querySelectorAll('[data-st-app]')).forEach(function (a) {
      a.addEventListener('click', function () {
        /* the app takes over; the page comes back with the door shut */
        setTimeout(function () { self.closeDoor(true); }, 400);
      });
    });
  };
  Stores.prototype.openDoor = function (store, opener) {
    if (!this.door || this.doorOpen) return;
    this.doorOpen = true;
    this.opener = opener || null;
    this.door.querySelector('[data-st-door-name]').textContent = store.name;
    this.door.querySelector('[data-st-door-addr]').textContent = store.addr;
    var apple = this.door.querySelector('[data-st-app="apple"]'), google = this.door.querySelector('[data-st-app="google"]');
    apple.setAttribute('href', store.apple);
    google.setAttribute('href', store.google);
    apple.setAttribute('aria-label', fill(this.S.directions_to, { name: store.name }) + ', Apple Maps');
    google.setAttribute('aria-label', fill(this.S.directions_to, { name: store.name }) + ', Google Maps');
    var host = document.querySelector('.header-wrapper .header') || document.querySelector('.header-wrapper');
    if (host) { host.appendChild(this.door); this.door.classList.add('svnty-door'); }
    this.door.hidden = false;
    document.body.classList.add('overflow-hidden');
    this.inert(true);
    var door = this.door;
    void door.offsetWidth;
    requestAnimationFrame(function () { door.classList.add('is-open'); });
    var sheet = this.sheet;
    requestAnimationFrame(function () { requestAnimationFrame(function () { try { sheet.focus({ preventScroll: true }); } catch (e) { sheet.focus(); } }); });
  };
  Stores.prototype.closeDoor = function (quiet) {
    if (!this.doorOpen) return;
    this.doorOpen = false;
    this.door.classList.remove('is-open');
    this.door.hidden = true;
    this.inert(false);
    if (this.door.parentNode !== this.doorHome) this.doorHome.appendChild(this.door);
    this.door.classList.remove('svnty-door');
    document.body.classList.remove('overflow-hidden');
    if (!quiet && this.opener && this.opener.focus) { try { this.opener.focus({ preventScroll: true }); } catch (e) { this.opener.focus(); } }
  };
  /* every sibling on the path from the door to <body> goes inert while it is open, and comes back as it was */
  Stores.prototype.inert = function (on) {
    if (on) {
      this.inerted = [];
      var node = this.door;
      while (node && node.parentElement && node !== document.body) {
        var parent = node.parentElement;
        slice(parent.children).forEach(function (sib) {
          if (sib === node || sib.inert || sib.tagName === 'SCRIPT' || sib.tagName === 'STYLE') return;
          sib.inert = true; this.inerted.push(sib);
        }, this);
        node = parent;
      }
    } else {
      (this.inerted || []).forEach(function (el) { el.inert = false; });
      this.inerted = [];
    }
  };

  /* ---------------------------------------------------------------- the shopper's location: on the tap, never stored */
  Stores.prototype.wireLocate = function () {
    var btn = this.root.querySelector('[data-st-locate]'), note = this.root.querySelector('[data-st-privacy]');
    if (!btn || !('geolocation' in navigator) || !window.isSecureContext) return;
    this.locateBtn = btn;
    btn.hidden = false;
    if (note) note.hidden = false;
    var self = this;
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      self.say(self.S.locating);
      navigator.geolocation.getCurrentPosition(function (pos) {
        btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading');
        self.locate({ lat: pos.coords.latitude, lng: pos.coords.longitude });
      }, function (err) {
        btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading');
        var code = err && err.code;
        self.say(code === 1 ? self.S.denied : code === 3 ? self.S.timeout : self.S.unavailable);
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    });
  };
  Stores.prototype.locate = function (here) {
    this.here = here;
    var self = this;
    var ranked = this.cards.map(function (card) {
      var st = self.byCode[card.getAttribute('data-code')];
      return { card: card, st: st, d: st && isFinite(st.lat) ? km(here, st) : Infinity };
    }).sort(function (a, b) {
      /* a closed branch never outranks an open one */
      var ao = a.st && a.st.open ? 0 : 1, bo = b.st && b.st.open ? 0 : 1;
      return ao - bo || a.d - b.d;
    });
    ranked.forEach(function (r) {
      var slot = r.card.querySelector('[data-st-dist]');
      if (slot && isFinite(r.d)) { slot.textContent = fill(self.S.km_away, { km: kmWords(r.d) }); slot.hidden = false; }
      self.list.appendChild(r.card);
    });
    this.cards = ranked.map(function (r) { return r.card; });
    var nearest = ranked[0];
    if (!nearest || !nearest.st) return;
    var far = nearest.d > FAR_KM;
    this.say(fill(far ? this.S.far : this.S.sorted, { name: nearest.st.name, km: kmWords(nearest.d) }));
    if (this.map) {
      /* the new question is "which is nearest": the card of an earlier pick closes, the map frames you and the nearest */
      this.closePlace();
      this.drawHere();
      if (!far) this.frame([[here.lng, here.lat], [nearest.st.lng, nearest.st.lat]], 14);
    }
    if (this.active) this.renderPlace(this.byCode[this.active]);
  };

  /* ---------------------------------------------------------------- the map
     The marks, the motion and the access layer are the shared map kit's (svnty-map-kit.js): the branch pin is the front
     logo, a group is the ring with its count, the shopper is the ink dot, the flight's duration is the kit's. This file
     gives it the branches, the text twin and the card. */
  var EGYPT = [[24.7, 21.9], [36.95, 31.7]];
  Stores.prototype.bootMap = function () {
    var shell = this.root.querySelector('[data-st-shell]');
    if (!shell) return;
    this.shell = shell;
    this.frameEl = shell.querySelector('[data-st-frame]');
    this.place = shell.querySelector('[data-st-place]');
    var self = this, failed = false;
    var fail = function () {
      if (failed) return;
      failed = true;
      shell.classList.add('is-down');
      var down = shell.querySelector('[data-st-down]');
      if (down) down.hidden = false;
    };
    /* D11-9: the deadline counts VISIBLE time only (a hidden tab withholds rAF, so nothing boots there), and a late load recovers */
    var deadline = 0, spent = 0, tick = 0;
    var armDeadline = function () { if (document.hidden || failed) return; tick = Date.now(); deadline = setTimeout(fail, Math.max(0, BOOT_DEADLINE - spent)); };
    var onVis = function () { if (document.hidden) { clearTimeout(deadline); if (tick) spent += Date.now() - tick; tick = 0; } else armDeadline(); };
    document.addEventListener('visibilitychange', onVis);
    var clearDeadline = function () { clearTimeout(deadline); document.removeEventListener('visibilitychange', onVis); };
    var recover = function () {
      if (!failed) return;
      failed = false; shell.classList.remove('is-down');
      var down = shell.querySelector('[data-st-down]'); if (down) down.hidden = true;
    };
    armDeadline();
    var K = window.SvntyMapKit;
    if (!K) { clearDeadline(); fail(); return; }
    this.K = K;
    K.install();
    loadCss(shell.getAttribute('data-maplibre-css-url'));
    Promise.all([loadScript(shell.getAttribute('data-maplibre-url')), K.fontsReady(1500)]).then(function (r) {
      var gl = r[0];
      if (gl.supported && !gl.supported()) throw new Error('webgl');
      self.gl = gl;
      var map = new gl.Map(K.mapOptions({
        container: shell.querySelector('[data-st-map]'),
        style: shell.getAttribute('data-style-url'),
        bounds: EGYPT,
        fitBoundsOptions: { padding: 12 },
        minZoom: 3.5, maxZoom: 18,
        maxBounds: [[18, 15], [43, 37]],
        locale: { 'Map.Title': self.S.map_label, 'CooperativeGesturesHandler.MobileHelpText': self.S.map_hint }
      }));
      self.map = map;
      K.flatten(map);
      map.on('error', function () { /* a tile hiccup is not a dead map; the deadline covers a hang */ });
      /* a tile outage leaves the pins on a blank field: the kit's tile watch says so, one plain line (KIT_FIX P2-2) */
      if (K.health) K.health(map, function (ok) { self.tilesDown(!ok); });
      map.on('load', function () {
        // the city labels a pin sits on step aside (the pin names the place; the label would be covered): D9-12
        try { self.K.places(map, self.variant || (self.root.getAttribute('data-map-variant') === 'night' ? 'night' : 'paper')); } catch (e) {}
        try { self.K.quiet(map, ['Cairo', 'Al Qahirah', 'Nasr City', 'Madinat Nasr', '6th of October City', 'Sixth of October', 'Madinat Sittah Uktubar', 'Hurghada', 'Al Ghardaqah', 'Faiyum', 'Al Fayyum', 'Fayoum', 'Mansoura', 'El Mansoura', 'Al Mansurah', 'Zagazig', 'Az Zaqaziq', '10th of Ramadan City', 'Obour City', 'El Obour']); } catch (e) {}
        clearDeadline();
        recover();                                  /* a map that loads after the clock is a live map */
        shell.classList.add('is-live');
        self.home = { center: map.getCenter(), zoom: map.getZoom() };
        self.access();
        self.wireControls();
        self.drawPins();
        slice(self.root.querySelectorAll('[data-st-show]')).forEach(function (b) { b.hidden = false; });
        if (self.here) self.drawHere();
      });
    }).catch(function () { clearDeadline(); fail(); });
  };
  Stores.prototype.tilesDown = function (on) {
    var note = this.shell && this.shell.querySelector('[data-st-tiles-down]');
    if (!note || note.hidden === !on) return;
    note.hidden = !on;
    if (on) this.say(note.textContent);
  };
  Stores.prototype.pad = function () {
    var w = this.frameEl ? this.frameEl.clientWidth : 360;
    var p = Math.round(Math.max(40, Math.min(72, w * 0.12)));
    return { top: p, bottom: p, left: p, right: p + 36 };
  };
  /* the map is named, tied to the list's heading, and speaks what it now shows */
  Stores.prototype.access = function () {
    var id = this.root.querySelector('[data-st-map]').id + '-desc';
    var p = document.createElement('p');
    p.id = id; p.className = 'svnty-stores__sr';
    p.textContent = fill(this.S.map_desc, { count: this.stores.filter(function (s) { return s.open; }).length });
    this.frameEl.appendChild(p);
    /* one named region: the frame holds the canvas and the zoom group (KIT_FIX P2-5); the credit line sits under it */
    this.voice = this.K.label(this.map, { label: this.S.map_label, describedBy: id, canvasLabel: this.S.map_label + '. ' + p.textContent, region: this.frameEl });
    /* D11-4 THE CLEAN MAP: the kit's (i) in the frame's corner, folded from the first frame (nothing on the map opens by itself; a tap opens the credit) */
    /* 2026-09-26 ~22:05 (R250): no (i) either; the data licences are stated in the Terms of Service §11 (the kit's credit stays available) */
  };
  /* the controls: the kit's one group (zoom in, zoom out, the whole country), disabled at the limits */
  Stores.prototype.wireControls = function () {
    var self = this, host = this.root.querySelector('[data-st-ctl]');
    if (!host) return;
    host.appendChild(this.K.controls(this.map, {
      labels: { 'in': this.S.zoom_in, out: this.S.zoom_out, frame: this.S.fit_all },
      groupLabel: this.S.controls,
      // a zoom in steps about the branches in view, so the country view's + keeps the Delta's marks on the frame (D9-12b)
      around: function () {
        var b = self.map.getBounds(), n = 0, x = 0, y = 0;
        self.items().forEach(function (it) { if (b.contains(it.lngLat)) { n++; x += it.lngLat[0]; y += it.lngLat[1]; } });
        return n ? [x / n, y / n] : null;
      },
      onFrame: function () { self.fitAll(); self.say(self.S.all_branches); }
    }));
    host.hidden = false;
  };
  Stores.prototype.fitAll = function () {
    this.closePlace();
    if (this.K.reduce()) { this.map.fitBounds(EGYPT, { padding: 12, animate: false }); return; }
    this.map.fitBounds(EGYPT, { padding: 12, duration: this.K.flightMs(this.map.getZoom() - this.home.zoom), easing: this.K.ease });
  };
  Stores.prototype.items = function () {
    if (this._items) return this._items;
    this._items = this.stores.filter(function (s) { return isFinite(s.lat) && isFinite(s.lng); })
      .map(function (s) { return { id: s.code, lngLat: [s.lng, s.lat], store: s }; });
    return this._items;
  };
  /* the pins and the groups: pointer shortcuts only (hidden from Tab and screen readers by the kit); the list after the map
     carries every branch for the keyboard and the screen reader, and the skip link goes there */
  Stores.prototype.drawPins = function () {
    var self = this;
    // the country view keeps Cairo's branches together and lets Mansoura, Sharkeya, Fayoum and the Red Sea stand on their own (D9-12)
    this.pins = this.K.clusters(this.gl, this.map, this.items(), {
      size: 'm', padding: 64, radius: 34,
      onPick: function (it) { self.select(it.id, { from: 'pin' }); },
      onGroup: function (g) { self.say(fill(self.S.pin_cluster, { count: g.length })); }
    });
    /* hovering or focusing a card rings its pin (the kit's near state).
       THE iOS TAP LAW (P17-18, the code health audit's P2-4): a finger never rings it. iOS Safari sends the compatibility
       mouseenter to a tapped card before its click, and a visible change at that moment is what WebKit reads as "hover, hold
       the click"; pointerenter carries the pointer's type, so only a real mouse rings the pin. Focus keeps its ring. */
    this.cards.forEach(function (card) {
      var code = card.getAttribute('data-code');
      var on = function () { if (self.pins) self.pins.near(code); }, off = function () { if (self.pins) self.pins.near(null); };
      card.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') on(); });
      card.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') off(); });
      card.addEventListener('focusin', on); card.addEventListener('focusout', off);
    });
  };

  /* the shopper's dot */
  Stores.prototype.drawHere = function () {
    if (!this.map || !this.here) return;
    if (!this.hereMk) {
      var el = this.K.userDot();
      el.classList.add('svnty-stores__here');
      this.hereMk = new this.gl.Marker({ element: el, anchor: 'center' }).setLngLat([this.here.lng, this.here.lat]).addTo(this.map);
    } else {
      this.hereMk.setLngLat([this.here.lng, this.here.lat]);
    }
  };
  Stores.prototype.frame = function (pts, maxZoom) {
    this.K.frame(this.map, pts, { padding: this.pad(), maxZoom: maxZoom || BRANCH_Z });
  };

  /* ---------------------------------------------------------------- select: fly to the branch and open its card */
  Stores.prototype.select = function (code, opts) {
    var st = this.byCode[code];
    if (!st) return;
    opts = opts || {};
    this.active = code;
    this.cards.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-code') === code); });
    if (!this.map) return;
    if (this.pins) this.pins.select(code);
    if (opts.from === 'list') {
      /* P22-23 THE WHOLE MAP IN VIEW: the tracking page's slabAt (the bar comes back on the way up, parks on the way down); the
         page moves only as far as the frame needs, so a sticky map in view stays put and the card she pressed stays on the screen */
      var r = this.shell.getBoundingClientRect(), y = window.pageYOffset, absTop = y + r.top;
      var de = document.documentElement, cs = getComputedStyle(de);
      var now = parseFloat(cs.getPropertyValue('--svnty-headstack-h')) || 0, bar = parseFloat(cs.getPropertyValue('--svnty-ann-h')) || 0;
      var head = de.classList.contains('svnty-bar-hidden') ? now : Math.max(0, now - bar);
      var maxY = absTop - (absTop - head - 16 > y + 6 ? head : head + bar) - 16;   /* the top 16 px under the header */
      var minY = absTop + r.height + 16 - window.innerHeight;                     /* the foot 16 px over the window's */
      var want = y > maxY ? maxY : (y < minY ? Math.min(minY, maxY) : y);
      if (Math.abs(want - y) > 2) window.scrollTo({ top: Math.max(0, want), behavior: this.K.reduce() ? 'auto' : 'smooth' });
    }
    this.renderPlace(st);
    var off = this.placeOffset();
    var items = this.items(), it = items.filter(function (i) { return i.id === code; })[0];
    var z = this.K.branchZoom(it, items, 60);
    /* the kit's flight; under reduced motion it lands at once, beside the card as the flight would (KIT_FIX P1-4) */
    this.K.flyTo(this.map, [st.lng, st.lat], { zoom: z, offset: off });
    if (this.voice) this.voice.say(fill(this.S.selected, { name: st.name }));
  };
  Stores.prototype.placeOffset = function () {
    if (!this.place || this.place.hidden || !this.frameEl) return [0, 0];
    var fh = this.frameEl.clientHeight, fw = this.frameEl.clientWidth, pr = this.place.getBoundingClientRect(), fr = this.frameEl.getBoundingClientRect();
    var wide = pr.width < fw * 0.6;
    if (wide) {
      /* the card sits at the left: the branch goes to the middle of the free right part */
      var freeX = (pr.right - fr.left + fw) / 2;
      return [Math.round(freeX - fw / 2), 0];
    }
    var freeY = (pr.top - fr.top) / 2;
    return [0, Math.round(freeY - fh / 2)];
  };
  Stores.prototype.renderPlace = function (st) {
    var box = this.place;
    if (!box) return;
    var S = this.S, self = this;
    box.textContent = '';
    box.setAttribute('role', 'region');
    var hid = 'SvntyStorePlace-' + st.code.replace(/[^\w]/g, '');
    box.setAttribute('aria-labelledby', hid);
    if (st.photo) {
      var img = document.createElement('img');
      img.className = 'svnty-stores__place-photo';
      img.src = st.photo; img.alt = st.photoAlt || ''; img.decoding = 'async'; img.loading = 'lazy';
      box.appendChild(img);
    }
    var head = document.createElement('div');
    head.className = 'svnty-stores__place-head';
    var h = document.createElement('h3');
    h.className = 'svnty-stores__place-name'; h.id = hid;
    var en = document.createElement('span'); en.textContent = st.name; h.appendChild(en);
    if (st.nameAr) {
      var ar = document.createElement('span');
      ar.className = 'svnty-stores__name-ar'; ar.lang = 'ar'; ar.dir = 'rtl'; ar.textContent = st.nameAr;
      h.appendChild(document.createTextNode(' ')); h.appendChild(ar);
    }
    head.appendChild(h);
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'svnty-stores__place-close'; x.setAttribute('aria-label', S.close);
    // THE ICON LAW: the family's close glyph, cloned from the section's template (the inline mark only when the template is gone)
    var tplX = document.querySelector('template[data-svnty-icons] [data-icon="close"] svg, template[data-svnty-icons]');
    var iconX = tplX && tplX.content ? tplX.content.querySelector('[data-icon="close"] svg') : tplX;
    if (iconX) x.appendChild(iconX.cloneNode(true));   /* D11-3: the family's close only (the page's one template, svnty-glyphs) */
    x.addEventListener('click', function () { self.closePlace(true); });
    head.appendChild(x);
    box.appendChild(head);
    var addr = document.createElement('p'); addr.className = 'svnty-stores__place-addr'; addr.textContent = st.addr; box.appendChild(addr);
    if (st.addrAr) {
      var addrAr = document.createElement('p'); addrAr.className = 'svnty-stores__place-addr-ar'; addrAr.lang = 'ar'; addrAr.dir = 'rtl'; addrAr.textContent = st.addrAr;
      box.appendChild(addrAr);
    }
    var row = document.createElement('p'); row.className = 'svnty-stores__place-state';
    if (st.open) {
      var stEl = this.stateEl(st);
      if (stEl) row.appendChild(stEl);
    } else {
      var shut = document.createElement('span'); shut.className = 'svnty-stores__state svnty-stores__state--shut'; shut.textContent = S.temp_closed; row.appendChild(shut);
    }
    if (this.here) {
      var d = document.createElement('span'); d.className = 'svnty-stores__place-dist';
      d.textContent = fill(S.km_away, { km: kmWords(km(this.here, st)) });
      row.appendChild(d);
    }
    box.appendChild(row);
    if (st.open) {
      var wk = document.createElement('p'); wk.className = 'svnty-stores__place-week';
      [[S.sat_wed, st.satWed], [S.thu_fri, st.thuFri]].forEach(function (pair) {
        var sp = document.createElement('span'); sp.className = 'svnty-stores__week';
        sp.textContent = pair[0] + ' ' + weekWords(pair[1], S);
        wk.appendChild(sp);
      });
      box.appendChild(wk);
      var a = document.createElement('a');
      a.className = 'svnty-btn svnty-btn--full svnty-stores__place-go';
      a.href = st.google; a.target = '_blank'; a.rel = 'noopener nofollow';
      a.textContent = S.directions;
      a.setAttribute('aria-label', fill(S.directions_to, { name: st.name }));
      a.addEventListener('click', function (e) { self.directions(st.code, e, a); });
      box.appendChild(a);
    }
    box.hidden = false;
    this.shell.classList.add('has-place');
  };
  Stores.prototype.closePlace = function (restore) {
    if (!this.place || this.place.hidden) return;
    var code = this.active;
    this.place.hidden = true;
    this.place.textContent = '';
    this.shell.classList.remove('has-place');
    this.active = null;
    if (this.pins) this.pins.select(null);
    this.cards.forEach(function (c) { c.classList.remove('is-active'); });
    if (restore && code) {
      var btn = this.cardByCode[code] && this.cardByCode[code].querySelector('[data-st-show]');
      if (btn && document.activeElement && this.frameEl.contains(document.activeElement)) btn.focus({ preventScroll: true });
    }
  };

  function start() {
    slice(document.querySelectorAll('[data-svnty-stores]')).forEach(function (root) {
      if (root.__svntyStores) return;
      root.__svntyStores = new Stores(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
  /* the probe's handle: the page's own instance, for the guard only */
  window.SvntyStores = { instances: function () { return slice(document.querySelectorAll('[data-svnty-stores]')).map(function (r) { return r.__svntyStores; }); } };
}());
